import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
// import { Footer, Navbar } from "../../components";
import { Navbar, Footer } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears, renderStars } from "../Utils";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../../css/SliderStyles.css";// Custom styles
// import "../../css/Tabs.css";
// import "../../assets/css/bootstrap.min.css";
// import "../../assets/css/fontawesome-all.min.css";
// import "../../assets/css/slick.css";
// import "../../assets/css/line-awesome.min.css";
// import "../../assets/css/main.css";
// import "../../assets/css/responsive.css";
import "../../assets/css/fontawesome-all.min.css";
// import "../../src/assets/css/slick.css";
// import "../../src/assets/css/line-awesome.min.css";
// import "../../src/assets/css/main.css";

import "../../assets/stylesheet/bootstrap.min.css";
import "../../assets/stylesheet/all-fontawesome.min.css";
import "../../assets/stylesheet/animate.min.css";
import "../../assets/stylesheet/magnific-popup.min.css";
import "../../assets/stylesheet/owl.carousel.min.css";
import "../../assets/stylesheet/style.css";
import SearchIcon from "../../assets/images/all/search.svg";

import StarIcon from "../../assets/images/all/star-svgrepo-com.svg";
import LectureImage from "../../assets/images/all/leachure.png";
import { debounce } from 'lodash'; // Optional for debouncing
import shapeImage from "../../assets/images/all/shape_1.png";
import shapeImage1 from "../../assets/images/icons/Unions.svg";
import shapeImage2 from "../../assets/images/icons/Union-2.svg";
import SliderImagess from "../../assets/images/course/image-1.png";
import SliderImagess2 from "../../assets/images/course/image-2.png";
import backgroundBanner1 from "../../assets/img/logo/element1.png";
import instituteBanner from "../../assets/img/institute/banner-bg.jpg";
import menuShape from "../../assets/img/logo/menu-shape.png";
import thumb1 from "../../assets/img/logo/thumb1.png";
import curveBg from "../../assets/img/logo/curve.png";
import addGirl from "../../assets/img/add/add-girl.png";
import addBanner from "../../assets/img/add/add-banner.jpg";
import VideoSlider from "../../components/VideoSlider";
import BranchSlider from "../../components/BranchSlider";

// {profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : null}

const CustomArrow = ({ className, style, onClick, isLeft }) => {
    return (
        <div
            className={className}
            style={{
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
                color: 'black',
                borderRadius: '50%',
                position: 'absolute',
                top: '50%', // Center vertically
                transform: 'translateY(-50%)', // Adjust for arrow size
                [isLeft ? 'left' : 'right']: '10px', // Adjust horizontal position
                zIndex: 2, // Ensure it's above the image
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
            onClick={onClick}
        >
            {isLeft ? '<' : '>'}
        </div>
    );
};

const InstituteInfoDetail = (props) => {
    const { id } = useParams();
    const [ids, setIds] = useState(id);
    console.log(ids);
    const [mainSlider, setMainSlider] = useState(null);
    const [thumbSlider, setThumbSlider] = useState(null);
    const [activeTab, setActiveTab] = useState("All");
    const [mediaimg, setMediaimg] = useState("");
    const [profileimg, setProfileimg] = useState(""); // State to hold roles data
    const [aboutInfo, setAboutInfo] = useState({
        about_info: "",
    });
    const [profileData, setProfileData] = useState({
        id: "",
        full_name: "",
        email_id: "",
        username: "",
        location: "",
    });

    const [otherInfoDetails, setOtherInfoDetails] = useState({
        no_of_students_studyind: "",
        year_of_establishment: "",
        timings: "",
        hostels: "",
        approved_by: "",
        affiliation: "",
        gender_composition: "",
    });

    const [streamDetails1, setStreamDetails1] = useState([]);
    const [facilitydata, setFacilityData] = useState([])
    const [instituteFollower, setInstituteFollower] = useState([]);
    const [rating, setRating] = useState(0);
      const [instituteId, setinstituteId] = useState([]);
      const [averageRatings, setAverageRatings] = useState([]);
    const tabs = ["All", "Management", "Technology", "Design"];
    const location = useLocation();
    const { message } = location.state || {};
    console.log("message //////", message)
    const sliderImages = [
        { src: SliderImagess, alt: "Woxsen University 1" },
        { src: SliderImagess2, alt: "Woxsen University 2" },
        { src: SliderImagess, alt: "Woxsen University 3" },
        { src: SliderImagess2, alt: "Woxsen University 4" },
        { src: SliderImagess, alt: "Woxsen University 5" },
    ];



    // Main slider settings
    const mainSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: thumbSlider,
        prevArrow: <CustomArrow isLeft={true} />,
        nextArrow: <CustomArrow isLeft={false} />,
    };



    const thumbnailSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true, // Enable click to select thumbnail
        asNavFor: mainSlider, // Synchronize with main slider
        arrows: false, // Hide arrows for thumbnail slider
    };

    useEffect(() => {
        fetchProfile();
        fetchMedia();
        fetchAboutInfoDetails();
        fetchPersonalInfoDetails();
        // GetinstituteManagerPersonalInfo()
    }, []);
    
    const fetchProfile = async () => {
        // alert(ids)
        axios.get(`${API_BASE_URL}/getprofileImgDetails?user_id=${ids}`)
            .then(function (response) {
                // console.log(response.data.code);
                if (response.data.code == 200) {
                    console.log("4454444544545======", response.data.data[0]);
                    setProfileimg(response.data.data[0]);
                }
            })
            .catch(function (error) {
                console.log("1111121212122112", error);
            });
    };

    const fetchMedia = async () => {
        axios.get(`${API_BASE_URL}/getinstituteMediaDetails?user_id=${ids}`)
            .then(function (response) {
                console.log("Institute media", response);
                if (response.data.code == 200) {
                    setMediaimg(response.data.data);
                }
            })
            .catch(function (error) {
            });
    };



    const fetchAboutInfoDetails = async () => {

        axios.get(`${API_BASE_URL}/getInstitutesDataById/${ids}`)
            .then(function (response) {
                console.log("about ", response);
                if (response.data.code == 200) {
                    // console.log(response.data.data[0]);
                    //setbioInfoDetails(response.data.data[0]);
                    setAboutInfo({
                        id: response.data.data[0]["id"],
                        about_info: response.data.data[0]['about_info'],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchPersonalInfoDetails = async () => {

        axios.get(`${API_BASE_URL}/getpersonalInfoDetails?user_id=${ids}`)
            .then(function (response) {
                console.log(response);
                if (response.data.code == 200) {
                    console.log(response.data.data[0]);
                    //setpersonalInfoDetails(response.data.data[0]);
                    setProfileData({
                        id: response.data.data[0]["id"],
                        full_name: response.data.data[0]["full_name"],
                        email_id: response.data.data[0]["email_id"],
                        username: response.data.data[0]["username"],
                        location: response.data.data[0]["location"],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    useEffect(() => {
        const fetchInstituteFollowers = async () => {
        axios.get(`${API_BASE_URL}/getInstitutefollowers?institute_id=${profileData?.id}`)
            .then(function (response) {
                if (response.status == 200) {
                    setInstituteFollower(response.data);
                }
            })
            .catch(function (error) {
                console.log("1111121212122112", error);
            });
        };
    
        fetchInstituteFollowers();
      }, [profileData]); // Run the effect when cartItems changes
    
// Rating start
const fetchRatings = async () => {
    
    try {
     
        promises =  axios.get(`${API_BASE_URL}/ratings/institute/${profileData?.id}`)
        console.log(promises);
      const responses = await Promise.all(promises);
      console.log(responses);
      const courserating = responses?.map(response => response.data.data);
      const averageRatingsss = courserating?.map((ratingsArray) => {
        return calculateAverageRating(ratingsArray);
      });

      //setRatings(courserating);
      setAverageRatings(averageRatingsss);
      renderStars(averageRatingsss)
    } catch (err) {
      
    } finally {
      
    }
  };
  useEffect(() => {
    fetchRatings();
  }, [profileData]);

useEffect(() => {
    console.log("Updated bio_info:", aboutInfo.about_info);
}, [aboutInfo]);

  const calculateAverageRating = (ratingsArray) => {
    if (!ratingsArray || ratingsArray.length === 0) return "0.00";
    const totalRating = ratingsArray.reduce((sum, ratingObj) => sum + ratingObj.rating, 0);
    return (totalRating / ratingsArray.length).toFixed(2); // Return average rounded to 2 decimal places

  };

  const bannerPadhaiStyle1 = {
    backgroundImage: `url(${backgroundBanner1})`,
  };
  
  const instituteBannerStyle = {
    backgroundImage: mediaimg ? `url(${Image_Base_Url}${encodeURIComponent(mediaimg.media_image_path)})` : "none",
  };

  const curvebgStyle = {
    backgroundImage: `url(${curveBg})`,
  };

  // {profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : null}
  // Rating end
    return (
        <>
        <Navbar />
        <main class="main">
            <section class="banner_padhai">
                <div class="banner_padhai1" style={bannerPadhaiStyle1}></div>
                <div class="hero-section">
                    <div class="">
                        <div class="hero-single pd-banner banner_pd_bottom">
                            <div class="container">
                                {/* <div class="text-center form-group srch_area mt-3 layer_up">
                                    <input type="search" name="search-field" placeholder="Find Institute, Colleges, Courses, Exams" required="" /><i class="far fa-search srch_glass"></i>
                                    <button type="submit">Search</button>
                                </div> */}
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="pd-dashboard-banner-bg mt-30" style={instituteBannerStyle}>
                                            <div class="profile_img_chng">
                                                <a href="#" class="tp-btn-add-course"><i class="fa-light fa-camera"></i> </a>
                                            </div>
                                            <div class="pd-instructor-wrap d-flex justify-content-between ">
                                                <div class="tp-instructor-info d-flex position-relative">
                                                    <div class="pd-profile-pic-btn">
                                                        <a href="#" class="tp-btn-add-course"><i class="fa-regular fa-plus"></i> </a>
                                                    </div>
                                                    <div class="pd-instructor-avatar">
                                                        <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : null} alt="profile" />
                                                    </div>
                                                    <div class="pd-instructor-content">
                                                        <h4 class="pd-instructor-title">{profileData?.full_name}</h4>
                                                        <div class="pd-instructor-rate d-flex align-items-center">
                                                            <div class="pd-instructor-rating">
                                                                {renderStars(averageRatings)}
                                                            </div>
                                                            <span>{String(averageRatings)}</span>
                                                            <span> Ratings </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="banner_padhai1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="pd_outerall">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="pd-user-sidebar">
                                <div class="pd-user-wrap">
                                    <div class="pd-user-menu">
                                        <nav>
                                            <ul>
                                                <li class="pd-user-menu-section">
                                                    <p class="pd-user-menu-title">Welcome</p>
                                                    <ul>
                                                        <li>
                                                            <a href="#" class="active">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Dashboard
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="/InstituteAbout/1" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> About Us
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                    </span> Posts
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                    </span> Courses
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Videos
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Admission Form
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                        <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                        <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Reviews
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li class="pd-user-menu-section">
                                                    <p class="pd-user-menu-title space-gap">User</p>
                                                    <ul>
                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M7.60509 10.2644C6.32151 10.2644 5.2832 9.26439 5.2832 8.00839C5.2832 6.75239 6.32151 5.74438 7.60509 5.74438C8.88867 5.74438 9.90245 6.75239 9.90245 8.00839C9.90245 9.26439 8.88867 10.2644 7.60509 10.2644Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M14.9841 9.896C14.8288 9.656 14.608 9.416 14.3219 9.264C14.093 9.152 13.9458 8.968 13.815 8.752C13.398 8.064 13.6433 7.16 14.3382 6.752C15.1558 6.296 15.4174 5.28 14.9432 4.488L14.3955 3.544C13.9294 2.752 12.9075 2.472 12.0981 2.936C11.3786 3.32 10.4548 3.064 10.0378 2.384C9.90702 2.16 9.83344 1.92 9.84979 1.68C9.87432 1.368 9.77621 1.072 9.62905 0.832C9.32655 0.336 8.77878 0 8.17378 0H7.02101C6.42419 0.016 5.87642 0.336 5.57392 0.832C5.41858 1.072 5.32865 1.368 5.345 1.68C5.36135 1.92 5.28777 2.16 5.15696 2.384C4.74 3.064 3.81615 3.32 3.10487 2.936C2.28731 2.472 1.27352 2.752 0.799336 3.544L0.251567 4.488C-0.214445 5.28 0.0471757 6.296 0.856566 6.752C1.5515 7.16 1.79677 8.064 1.38798 8.752C1.249 8.968 1.10184 9.152 0.872917 9.264C0.594945 9.416 0.349675 9.656 0.218865 9.896C-0.0836348 10.392 -0.0672835 11.016 0.235216 11.536L0.799336 12.496C1.10184 13.008 1.66596 13.328 2.2546 13.328C2.53258 13.328 2.8596 13.248 3.12122 13.088C3.32561 12.952 3.57088 12.904 3.84068 12.904C4.65007 12.904 5.32865 13.568 5.345 14.36C5.345 15.28 6.09716 16 7.04554 16H8.15743C9.09763 16 9.84979 15.28 9.84979 14.36C9.87432 13.568 10.5529 12.904 11.3623 12.904C11.6239 12.904 11.8692 12.952 12.0817 13.088C12.3434 13.248 12.6622 13.328 12.9484 13.328C13.5288 13.328 14.093 13.008 14.3955 12.496L14.9678 11.536C15.2621 11 15.2866 10.392 14.9841 9.896Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Settings
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.4" d="M9.94863 0C10.3714 0 10.7222 0.341829 10.7222 0.773613V17.2264C10.7222 17.6492 10.3804 18 9.94863 18C4.65028 18 0.953125 14.3028 0.953125 9.0045C0.953125 3.70615 4.65927 0 9.94863 0Z" fill="currentColor"></path>
                                                                        <path d="M16.5143 8.58188L13.9596 6.01816C13.6987 5.75729 13.2669 5.75729 13.006 6.01816C12.7452 6.27903 12.7452 6.71082 13.006 6.97169L14.4093 8.37498H5.80064C5.43182 8.37498 5.12598 8.68083 5.12598 9.04965C5.12598 9.41846 5.43182 9.72431 5.80064 9.72431H14.4093L13.006 11.1276C12.7452 11.3885 12.7452 11.8203 13.006 12.0811C13.141 12.2161 13.3119 12.279 13.4828 12.279C13.6537 12.279 13.8246 12.2161 13.9596 12.0811L16.5143 9.51741C16.7752 9.26554 16.7752 8.84275 16.5143 8.58188Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Logout
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div class="pd-user-banner d-flex align-items-center">
                                        <div class="pd-user-banner-text">
                                            <h4 class="pd-user-banner-title">Online Education</h4>
                                            <div class="pd-user-banner-btn">
                                                <a href="#" class="theme-btn">View Course</a>
                                            </div>
                                        </div>
                                        <div class="tp-user-banner-shape"><img src={menuShape} alt="user-banner" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-9">
                            <div class="row banner_social">
                                <div class="col-md-12">
                                    <div class="pd-user-banner-btn">
                                        <a href="#" class="theme-btn veryfied me-2"  onClick={(e) => e.preventDefault()}>Veryfied <i class="fa-regular fa-check"></i></a>
                                        <a href="#" class="theme-btn connect me-2"  onClick={(e) => e.preventDefault()}> Connect Me <i class="fa-light fa-handshake"></i></a>
                                        <a href="#" class="theme-btn share"  onClick={(e) => e.preventDefault()}> Share <i class="fa-regular fa-share-nodes"></i></a>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="pd-sidebar-box-right">
                                <section class="rating pt-4">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="site-heading mb-3">
                                                <h3 class="site-title">ABOUT US</h3>
                                            </div>
                                            {aboutInfo.about_info && (
                                                <p dangerouslySetInnerHTML={{ __html: aboutInfo.about_info }}></p>
                                            )}
                                            
                                        </div>
                                    </div>
                                </section>
                                <section class="rating pt-4">
                                    <div class="row">
                                        <div class="col-lg-12 text-center">
                                            <div class="site-heading text-center mb-3">
                                                <h3 class="site-title">How Would You Rate This Page</h3>
                                            </div>
                                            <p><em>We will use this feedback to improve your experience</em></p>
                                            <div class="pd_10 pb-0 video_title">
                                                <div class="course-rating">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="far fa-star"></i>
                                                </div>
                                            </div>
                                            <h5 class="pt-3"><em>Rate Us Now</em></h5>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Footer />
        </>
    );
};

export default InstituteInfoDetail;